<template>
  <div class="page_box">
        <sample-management-list></sample-management-list>
      </div>
</template>

<script>
import FoodTraceability from "@/components/FoodTraceability";
import foodCanteenSelect from "./components/foodCanteenSelect";
import sampleManagementList from "./components/sampleManagementList";
export default {
  name: "",
  components: {
    FoodTraceability,
    foodCanteenSelect,
    sampleManagementList,
  },
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style scoped></style>
